var exports = {
  "xP": "toolGroupHeader__ATEJk7",
  "Sz": "toolGroupContentWrapper__gL71Lj",
  "mZ": "connectorLine__1FlRBE",
  "xb": "toolGroupContent__wlTY5X",
};

module.exports = exports;
